function validateRoute(route: string, permitted: object, _default: string): string {
  return Object.values(permitted).find(r => r === route) || _default
}

export default validateRoute
